define('home/views/NotificationCardChannelInviteView',[
    'home/views/ForumCardView',
    'home/views/common/ActivityCardView',

    'home/mixins/withReason',
    'home/mixins/withSubviews',
    'home/mixins/asNotificationCard',
    'home/mixins/withTruncate',
    'home/mixins/withChannelAvatar',

    'home/templates/notificationCardChannelInvite',
], function (
    ForumCardView,
    ActivityCardView,

    withReason,
    withSubviews,
    asNotificationCard,
    withTruncate,
    withChannelAvatar,

    notificationCardChannelInviteTemplate
) {
    'use strict';

    var parent = ActivityCardView;

    /**
     * Returns the channel from the first ChannelInviteActivity rolled
     * up in the ActivityFeedItem model.
     */
    var getChannel = function () {
        return this.model.activities[0].channel;
    };

    /**
     * A notification card showing an invitation to a channel.
     *
     * Expects an ActivityFeedItem model with at least 1 ChannelInviteActivity
     * rolled up.
     */
    var NotificationCardChannelInviteView = parent.extend({
        className: 'card-notif-channel-invite card-notif-note',

        regions: {
            contentRegion: '[data-role=content]',
        },

        template: notificationCardChannelInviteTemplate,
        templateHelpers: function () {
            return {
                channel: getChannel.call(this).toJSON(),
            };
        },

        onRender: function () {
            this.activateRegion(this.contentRegion, this.createContentView);
        },

        createContentView: function () {
            return new ForumCardView({
                model: getChannel.call(this).primaryForum,

                // Override className on ForumCardView (which styles view as a
                // standalone card) since here it's used as a subview
                className: '',
            });
        },

        // By defining this, the asNotificationCard mixin will add in the view/click
        // tracking calls.
        getAnalyticsPayload: function (verb) {
            var channel = getChannel.call(this);
            var backendId = this.model.activities[0].get('backendId');
            return {
                verb: verb,
                object_type: 'note',
                object_id: backendId,
                note_template_id: backendId,
                note_template_name: ['channel', 'invite', channel.id].join(' '),
            };
        },
    });

    withReason.call(NotificationCardChannelInviteView.prototype);
    asNotificationCard.call(NotificationCardChannelInviteView.prototype);
    withTruncate.call(NotificationCardChannelInviteView.prototype);
    withChannelAvatar.call(NotificationCardChannelInviteView.prototype, getChannel);
    withSubviews.call(NotificationCardChannelInviteView.prototype);

    return NotificationCardChannelInviteView;
});

